import React, { useEffect, useState } from "react";

// Boot animation: /boot-animation.html (a self-contained animated page,
// not a lightweight snippet — sandboxed with allow-scripts only, no
// allow-same-origin, so it runs in an isolated opaque origin with no
// access to the app's own cookies/localStorage/DOM) plays for a fixed
// duration, then fades out. There's no reliable "animation finished"
// signal from an arbitrary iframe, so — unlike the old video, which
// dismissed on its own `ended` event — DISPLAY_MS is the actual
// dismiss timer, not just a safety fallback.
const DISPLAY_MS = 3500;
const FADE_MS = 400;

export function Splash({ onDone }: { onDone: () => void }) {
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setFading(true), DISPLAY_MS);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!fading) return;
    const done = setTimeout(onDone, FADE_MS);
    return () => clearTimeout(done);
  }, [fading, onDone]);

  return (
    <div className="splash-overlay" style={{ opacity: fading ? 0 : 1 }}>
      <iframe
        className="splash-video"
        src="/boot-animation.html"
        title="Boot animation"
        sandbox="allow-scripts"
        style={{ border: 0, width: "100%", height: "100%" }}
      />
    </div>
  );
}
